import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isChallengesMultiChoice(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHALLENGES_MULTI_CHOICE && typeof label === 'string' && Array.isArray(value) && value.every(item => typeof item === 'string');
}
function _formatChallengesMultiChoice(_ref) {
  let {
    field,
    value
  } = _ref;
  if (value.length === 0) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatChallengesMultiChoice(submission) {
  if (isChallengesMultiChoice(submission)) {
    return _formatChallengesMultiChoice(submission);
  }
  return undefined;
}
//# sourceMappingURL=challenges-multi-choice-preview.js.map